import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { basicReports } from 'store/entities/professionalReport/selectors/basicDataSelectors';
import { sumArrayByAttribute } from 'utils/data';

import { Col, Row } from 'antd';
import ReportsTable from 'components/reusable/report/tables/ReportsTable';
import CompanyDataCard from '../../../components/reusable/CompanyDataCard';
import { ReactComponent as ReportsNumberIcon } from 'assets/img/icons/cardIcons/reportsNumber.svg';

const Reports = () => {
  const { t } = useTranslation();
  const { statisticsBySector } = useSelector(basicReports);

  const numberOfReportsDataSource = useMemo(
    () => [
      {
        sectorTitle: t('professionalReport.basicData.reports.total'),
        lastMonth: sumArrayByAttribute(statisticsBySector, 'lastMonth'),
        lastQuarter: sumArrayByAttribute(statisticsBySector, 'lastQuarter'),
        lastHalfYear: sumArrayByAttribute(statisticsBySector, 'lastHalfYear'),
        nested: statisticsBySector,
      },
    ],
    []
  );

  return (
    <CompanyDataCard icon={<ReportsNumberIcon />} title={t('professionalReport.basicData.reports.title')}>
      <Row className="space-bottom-sm no-break" style={{ pageBreakInside: 'avoid', pageBreakAfter: 'auto' }}>
        <Col xs={24} md={24}>
          <ReportsTable reports={numberOfReportsDataSource} />
        </Col>
      </Row>
    </CompanyDataCard>
  );
};

export default Reports;
